import { render, staticRenderFns } from "./FrequencySettingsMonthlyPerWeek.vue?vue&type=template&id=53b10ea0"
import script from "./FrequencySettingsMonthlyPerWeek.vue?vue&type=script&lang=ts"
export * from "./FrequencySettingsMonthlyPerWeek.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53b10ea0')) {
      api.createRecord('53b10ea0', component.options)
    } else {
      api.reload('53b10ea0', component.options)
    }
    module.hot.accept("./FrequencySettingsMonthlyPerWeek.vue?vue&type=template&id=53b10ea0", function () {
      api.rerender('53b10ea0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/frequency/FrequencySettingsMonthlyPerWeek.vue"
export default component.exports